var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 8,
    viewBox: "0 0 24 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3536 4.35356C23.5488 4.1583 23.5488 3.84171 23.3536 3.64645L20.1716 0.46447C19.9763 0.269207 19.6597 0.269207 19.4645 0.464469C19.2692 0.659732 19.2692 0.976314 19.4645 1.17158L22.2929 4L19.4645 6.82843C19.2692 7.02369 19.2692 7.34028 19.4645 7.53554C19.6597 7.7308 19.9763 7.7308 20.1716 7.53554L23.3536 4.35356ZM-8.74228e-08 4.5L23 4.5L23 3.5L8.74228e-08 3.5L-8.74228e-08 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.797ecb540b6bbfb522bf467dde313ef5.svg";
export { ForwardRef as ReactComponent };